module.exports = __webpack_public_path__ + "img/find-more-expenses-1.59380f4c.svg";